import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    minWidth: 113,
    lineHeight: '20px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#1D39C4',
    backgroundColor: '#D6E4FF',
    border: '1px solid #1D39C4',
    fontSize: 12,
  },
}));
